import React from 'react';
import { T } from 'Actions/translate';

class OrderPurchaseNo extends React.Component {
    render() {
        const { purchaseNo, className } = this.props;

        if(!purchaseNo) return null;

        return (
            <div className={ className }>
                <label>{T('order_po_number_colon')}</label>
                <p>{ purchaseNo }</p>
            </div>
        );
    }
}

export default OrderPurchaseNo;
